<template>
  <div class="section-partner">
    <div class="section-header">
      <div class="section-header-highlight title-letter-spacing">
        {{ getWordings.partnerSectionOurPartnerSubtitle }}
      </div>
      <div class="section-header-text">{{ getWordings.partnerSectionOurPartnerTitle }}</div>
    </div>
    <div class="items-wrapper">
      <PartnerView
        class="part-item"
        v-for="(item, idx) in this.partners"
        :key="idx"
        :image="item.image"
        :name="item.name"
      />
    </div>
  </div>
</template>

<script lang="ts">
import Vue from "vue";
import { Component } from "vue-property-decorator";
import { Getter } from "vuex-class";
import PartnerView from "@/components/parts/PartnerView.vue";
import CheckBox from "@/components/controls/CheckBox.vue";
import Tag from "@/components/controls/Tag.vue";

import RepositoryFactory from "@/lib/http/RepositoryFactory";

@Component({
  components: {
    PartnerView,
    CheckBox,
    Tag
  },
  inject: ["routes"]
})
export default class SectionOurPartner extends Vue {
  @Getter("text/getWordings") getWordings!: any;
  partners = [];

  created() {
    const contentRepository = RepositoryFactory.create("contents");
    this.getPartners(contentRepository);
  }

  async getPartners(contentRepository: any) {
    this.partners = (await contentRepository.getPartnersList()).map((item: any): any => {
      const cover = item.attributes.cover.data.attributes;
      return {
        name: item.attributes.name,
        image: cover.url,
        type: (item.attributes.type as string).toLowerCase()
      };
    });
  }
}
</script>

<style lang="scss" scoped>
.section-partner {
  @include size(100%, auto);
  @include layoutPadding();
  background: $gs8;
  padding-top: 100px;
  padding-bottom: 100px;

  .items-wrapper {
    @include flex(center, center);
    column-gap: 20px;
    row-gap: 84px;
    margin-top: 40px;
    margin-bottom: 40px;
  }

  .part-item {
    width: 224px;
    height: 150px;
  }

  .link-button {
    margin: 124px auto 0;
    @include mq(m) {
      margin-top: 55px;
    }
  }

  .button-wrapper {
    margin: 0 auto 0;
    @include mq(m) {
      margin-top: 55px;
    }
    .action-button {
      @include flex(center, center);
      margin: auto;
      width: 100%;
    }
  }

  .partner-filter {
    @include flex(flex-start, center);
    column-gap: 60px;
    border-top: 2px solid $gs7;
    border-bottom: 2px solid $gs7;
    padding: 20px;
    margin-top: 60px;
    @include mq(m) {
      column-gap: 10px;
      padding: unset;
      padding: 10px 0 10px;
      margin-top: 40px;
      @include fz(xs);
    }
  }

  .tags {
    @include flex(center, center);
    column-gap: 20px;
    width: 100%;
    padding: 20px 0;
    margin: 60px 0 0;
    border-bottom: 1px solid $gs7;
    border-top: 1px solid $gs7;
    @include mq(l) {
      @include flex(flex-start, center);
      flex-wrap: nowrap;
      margin: 40px 0 20px;
      column-gap: 5px;
      padding: 12px 0;
      overflow: hidden;
      overflow-x: scroll;
    }

    @include mq(m) {
      padding-left: 30px;
      padding-right: 30px;
      margin-left: -30px;
      width: calc(100vw - 60px);
    }

    .tag {
      @include fz(m);
      cursor: pointer;
      height: 40px;
      border-radius: 100px;
      background-color: $white;
      border: 1px solid $gs7;
      @include mq(m) {
        @include fz(xs);
        height: 30px;
      }
    }

    .tagActive {
      color: $white;
      background-color: $primary1;
      border: 0px solid $gs7;
    }
  }

  @include mq(m) {
    padding-top: 20px;
    padding-bottom: 40px;

    .group-title {
      @include fz(m);
      @include fw(medium);
      color: $gs3;

      &.group-1 {
        margin-top: 50px;
      }
      &.group-2 {
        margin-top: 20px;
      }
    }

    .items-wrapper {
      @include flex(space-between, center);
      column-gap: 10px;
      row-gap: 40px;
      margin-top: 10px;
      margin-bottom: 0;

      &:empty {
        margin-bottom: 30px;
      }
    }

    .part-item {
      width: calc(33.33% - 10px);
      height: 70px;
      padding: 0;
      margin-left: auto;
      margin-right: auto;
    }
  }
}
</style>
